import axios from "axios"


export const axios_backend = axios.create({
    baseURL: "https://travel-log-api.delft-circuits.com",
    // baseURL: "http://localhost:9000",
    timeout: 5000,
});
